import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { AccessibilityPage } from "./AccessibilityPage";
import { EmptyPortalPage } from "./EmptyPortalPage";
import { RolesPage } from "./RolesPage";

const pageModule = (): Module => ({
	id: "pageModule",
	views: () => viewComponentProvider
});

const components: Record<string, React.ComponentType<View> | undefined> = {
	AccessibilityPage,
	RolesPage,
	EmptyPortalPage
};

function viewComponentProvider(name: string): React.ComponentType<View> | undefined {
	return components[name];
}

export default pageModule;
